import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private httpClient: HttpClient,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getCoupons(partnerID: any, page, limit, showExpired, search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Coupons/Partner/${partnerID}?code=${this.env.key}&Page=${page}&Limit=${limit}${showExpired ? '&ShowExpired=true' : ''}${search ? '&CouponCode=' + search : ''}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalCoupons(partnerID: any, page, limit, showExpired, search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Rentals/Coupons/Partner/${partnerID}?code=${this.env.key}&Page=${page}&Limit=${limit}${showExpired ? '&ShowExpired=true' : ''}${search ? '&CouponCode=' + search : ''}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCouponDetail(partnerID: any, couponID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Coupon/Partner/${partnerID}/${couponID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalCouponDetail(partnerID: any, couponID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Rentals/Coupon/Partner/${partnerID}/${couponID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getLookupData(partnerID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Coupons/Partner/LookupData/${partnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalsLookupData(partnerID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Rentals/Coupons/Partner/LookupData/${partnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  checkCouponCodeExists(partnerID: any, couponCode: any, feature: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Coupon/Partner/Exists/${partnerID}/${couponCode}?code=${this.env.key}&Feature=${feature}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createCoupon(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Coupons/Partner?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createRentalsCoupon(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Rentals/Coupons/Partner?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateCoupon(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Coupons/Partner?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalsCoupon(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Rentals/Coupons/Partner?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  validateCouponCode(data: any) {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(
        'Authorization',
        `Bearer ${this.helpersService.getAuthDataNew().token}`,
      );

    return this.httpClient
      .post(
        this.env.url + `/Coupon/Validation/Portal?code=${this.env.key}`,
        data,
        { headers: headers },
      )
      .pipe(
        map((res) => res),
        catchError((res) => {
          return throwError(res);
        }),
      );
  }

  validateCouponCodeV2(data: any) {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(
        'Authorization',
        `Bearer ${this.helpersService.getAuthDataNew().token}`,
      );

    return this.httpClient
      .post(
        this.env.url + `/V2/Coupon/Validation/Portal?code=${this.env.key}`,
        data,
        { headers: headers },
      )
      .pipe(
        map((res) => res),
        catchError((res) => {
          return throwError(res);
        }),
      );
  }
}
